import React from "react";

function ProductGridEmpty(props) {
  const { children } = props;

  return <>{children}</>;
}

export default ProductGridEmpty;
